import React from "react";
import { Button, message, Upload } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import UploadOutlined from "@ant-design/icons/lib/icons/UploadOutlined";
import Compressor from 'compressorjs';

class ImageList extends React.Component {

    state = {
        fileList: [],
        uploading: false,
    };

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log(nextProps.documentData);
        if (nextProps && Array.isArray(nextProps.documentData)) {
            this.setState({ fileList: nextProps.documentData });
            // console.log(nextProps.documentData);
        }
    }

    compressor = (image, callback) => {
        try {
            const quality = image.size >= 2000000 ? 0.1 : image.size >= 500000 ? 0.3 : image.size >= 200000 ? 0.5 : 0.8;
            new Compressor(image, {
                quality,
                success: (compressedResult) => {
                    const sourceName = image.name || compressedResult.name || 'photo.jpeg';
                    const uniqueFileName = `${Date.now()}-${sourceName}`;
                    const file = new File([compressedResult], uniqueFileName, {
                        type: compressedResult.type,
                    });
                    file['uid'] = image.uid;
                    callback(file);
                },
            });
        } catch (e) {
            console.error(`Image compress error - `, e);
            callback(image);
        }
    };

    handleUpload = () => {
        const { fileList } = this.state;
        this.setState({
            uploading: true,
        });
        this.props.getDocumentData(fileList);

        if (this.props.resource && this.props.resource === 'PreVerification') {
            this.props.updateUploadedState(true);
        }
    };

    render() {
        const { uploading, fileList } = this.state;
        const props = {
            onRemove: file => {
                const { fileList } = this.state;
                const index = fileList.indexOf(file);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);
                this.setState({ fileList: newFileList }, () => {
                    this.handleUpload();
                });
            },
            beforeUpload: file => {
                const { fileList } = this.state;
                // Check if the file type is an image
                if (!file.type.startsWith('image/')) {
                    message.error('You can only upload image files!');
                    return false;
                }
                this.compressor(file, (cfile) => {
                    // console.log(fileList, cfile);
                    this.setState({
                        fileList: [...fileList, cfile],
                    }, () => this.handleUpload());
                });
                return false;
            },
            fileList,
            showUploadList: {
                showRemoveIcon: true,
                showPreviewIcon: true,
            },
            accept: 'image/*',
            capture: 'environment' // Add this line to enable camera
        };

        return (
            <div className='document-upload'>
                <Upload {...props}>
                    <Button>
                        <UploadOutlined /> Take Photo
                    </Button>
                </Upload>
            </div>
        );
    }
}

const mapStateToProps = ({ commonData }) => {
    return {}
};

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps())(ImageList);
ImageList.defaultProps = {};

ImageList.propTypes = {
    item: PropTypes.object
};
